import { I18nComponente } from "@/types/gerais"

export const MGraficoAtividadesPorPeriodoi18n: I18nComponente = {
  "pt-BR": {
    horasDeAtividadesPlanejadasXRealizadas: "Horas de atividades planejadas x realizadas",
    horasPlanejadas: "horas planejadas",
    horasRealizadas: "horas realizadas",
    asDatasInformadasNaoSaoValidas: "As datas informadas não são válidas",
    dataFinalDeveSerMaiorOuIgualDataInicial: "A data final deve ser maior ou igual à data inicial",
    cadaPeriodoIndicadoCorrespondeUmaSemana: "cada período indicado corresponde a uma semana"
  },
  "es-CO": {
    horasDeAtividadesPlanejadasXRealizadas: "Horas de actividades planeadas x realizadas",
    horasPlanejadas: "horas planeadas",
    horasRealizadas: "horas realizadas",
    asDatasInformadasNaoSaoValidas: "Las fechas informadas no son válidas",
    dataFinalDeveSerMaiorOuIgualDataInicial: "La fecha final debe ser mayor o igual a la fecha inicial",
    cadaPeriodoIndicadoCorrespondeUmaSemana: "cada período indicado corresponde a una semana"
  }
}
